module.exports = __webpack_public_path__ + "img/智驹LOGO.c5a94997.jpg";